import styled, { keyframes } from "styled-components";
import {
  FaMicrophone,
  FaLaptopCode,
  FaHandshake,
  FaTrophy,
  FaCoffee,
  FaUtensils,
  FaCalendarAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const sections = [
  {
    id: "A",
    label: "Inaugural Section",
    time: "9:00 AM – 10:15 AM",
    icon: <FaMicrophone />,
    color: "#791e1b",
    items: [
      { text: "Invocation" },
      {
        text: "Welcome Address & IITM Vision",
        speaker: "Prof. Ashwin Mahalingam",
        designation: "Dean – ACR, IIT Madras",
      },
      {
        text: "Address by Director, IITM",
        speaker: "Prof. V. Kamakoti",
        designation: "Director, IIT Madras",
      },
      {
        text: "Address by Guest of Honour",
        speaker: "Shri Jayant Chaudhary",
        designation:
          "Minister of State for Skill Development and Entrepreneurship",
      },
      {
        text: "Address by Chief Guest",
        speaker: "Shri Dharmendra Pradhan",
        designation: "Hon'ble Minister of Education",
      },
      {
        text: "Launch of Partnerships by Chief Guest",
        detail:
          "In the presence of Shri Sanjay Kumar (Secretary – School Education & Literacy), Dr. Vineet Joshi (Secretary – Higher Education, MoE) & Dr. Neeraj Mittal (Secretary – Ministry of Petroleum & Natural Gas)",
        subItems: [
          {
            speaker: "NTPC",
            designation: "Centre for Cardiovascular Research",
          },
          {
            speaker: "BPCL",
            designation:
              "Centre for NextGen Technologies for Robotic Assisted Surgeries – YANTRAS",
          },
          {
            speaker: "HSBC",
            designation:
              "Centre for Resource Efficiency, Recyclability & Circularity in Energy Transition",
          },
          {
            speaker: "Announcement",
            designation: "Bodhan AI",
          },
          {
            speaker: "Book Launch",
            designation:
              "Inventing a Better Tomorrow: 25 Years of IIT Madras Impact",
          },
        ],
      },
      {
        text: "Closing Remarks",
        speaker: "Mr. Kaviraj Nair",
        designation: "CEO – Office of Institutional Advancement, IITM",
      },
    ],
  },
  {
    id: "parallel",
    badge: "",
    label: "Parallel Sessions for Chief Guest & Guest of Honour",
    time: "10:15 AM – 11:30 AM",
    icon: <FaHandshake />,
    color: "#791e1b",
    items: [
      {
        text: "Session A",
        detail: "Visit to IITM Stalls & Interaction with IITM Faculty",
      },
      {
        text: "Session B",
        detail: "Interaction with IITM Corporate Partners",
      },
    ],
  },
  {
    id: "B",
    label: "Technology Showcase Section",
    time: "10:20 AM – 1:10 PM",
    icon: <FaLaptopCode />,
    color: "#791e1b",
    items: [
      {
        text: "Panel 1: Scalable Solutions for a Sustainable Future",
        speaker: "Keynote: Dr. Neeraj Mittal",
        designation: "Secretary – Ministry of Petroleum & Natural Gas",
      },
      {
        text: "Panel 2: Building Bharat's Semiconductor Ecosystem: Design, Fabrication, and Talent",
        speaker: "Keynote: Mr. S. Krishnan",
        designation: "Secretary – MeitY",
      },
      {
        text: "Panel 3: Startup Nation, Deep Tech Future: Building Scalable Innovation Ecosystems",
      },
      {
        text: "Expert Talk on Healthcare",
        speaker: "Prof. S. Mohanasankar",
        designation:
          "Faculty Head – Healthcare Technology Innovation Centre & Brain Centre, Dept of Electrical Engineering, IIT Madras",
      },
    ],
  },
  {
    id: "break1",
    label: "Networking Lunch & Visit to Stalls",
    time: "1:10 PM – 2:10 PM",
    icon: <FaUtensils />,
    isBreak: true,
  },
  {
    id: "C",
    label: "Impact & Innovation Section",
    time: "2:10 PM – 5:20 PM",
    icon: <FaHandshake />,
    color: "#791e1b",
    items: [
      {
        text: "Panel 4: Funding the Future: Corporate India's Role in Research Ecosystems",
        speaker: "Keynote: Mr. Shivkumar Kalyanaraman",
        designation: "CEO – ANRF",
      },
      {
        text: "Panel 5: Startups & Innovation – Lab to Launch: Translational Tech Startups",
        speaker: "Keynote: Prof. Nicolas Gascoin",
        designation:
          "Deputy Counsellor for Education, Science & Culture, French Consulate",
      },
      {
        text: "Expert Talk on AI",
        speaker: "Prof. Mitesh Khapra",
        designation:
          "Head – AI4Bharath and Bodhan.AI | Faculty, Dept of Data Science and AI, IIT Madras",
      },
      {
        text: "Panel 6",
        detail: "Skilling for the AI Economy: What Industry Needs from Academia",
      },
      {
        text: "Panel 7",
        detail: "Reimagining CSR for India's Future – Partner Showcase",
      },
    ],
  },
  {
    id: "D",
    label: "Valedictory Session",
    time: "5:50 PM – 6:30 PM",
    icon: <FaTrophy />,
    color: "#791e1b",
    items: [
      {
        text: "Welcome Address",
        speaker: "Prof. V. Kamakoti",
        designation: "Director, IIT Madras",
      },
      {
        text: "Keynote Speech",
        speaker: "Dr. Vineet Joshi",
        designation: "Secretary – Higher Education, Ministry of Education",
      },
      {
        text: "Keynote Speech",
        speaker: "Shri Sanjay Kumar",
        designation: "Secretary – School Education & Literacy",
      },
      {
        text: "Address by Guest of Honour",
        speaker: "Shri Sukanta Majumdar",
        designation: "Minister of State for Education (to be confirmed)",
      },
      {
        text: "Awards & Announcements by Guest of Honour",
        detail:
          "In the presence of: Shri Sanjay Kumar (Secretary – School Education & Literacy) & Dr. Vineet Joshi (Secretary – Higher Education, Ministry of Education)",
        subItems: [
          {
            speaker: "1. Power Grid Vidyalakshmi Scholarship",
            designation: "Announcement",
          },
          {
            speaker: "2. IITM Social Impact Awards 2026",
            designation: "Awards Distribution",
          },
          {
            speaker: "3. IITM Partnership Awards 2026",
            designation: "Notable Corporate CSR Partnerships with IITM",
          },
        ],
      },
      { text: "Visit to IITM Stalls by Guest of Honour" },
    ],
  },
  {
    id: "break2",
    label: "High Tea & Networking",
    time: "6:30 PM onwards",
    icon: <FaCoffee />,
    isBreak: true,
  },
];

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export default function Agenda() {
  return (
    <Section id="agenda">
      <HeaderBlock>
        <SectionTitle>Tentative Event Agenda</SectionTitle>
        <Divider />
        <MetaRow>
          <MetaItem>
            <FaCalendarAlt />
            <span>Tuesday, 5th May 2026</span>
          </MetaItem>
          <MetaItem
            as="a"
            href="https://www.google.com/maps?q=28.61974830991381,77.2410528313658"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt />
            <span>Leaders Lounge, Gate 7, Bharat Mandapam, New Delhi</span>
          </MetaItem>
        </MetaRow>
      </HeaderBlock>

      <Timeline>
        {sections.map((sec, idx) =>
          sec.isBreak ? (
            <BreakRow key={sec.id} style={{ animationDelay: `${idx * 0.08}s` }}>
              <BreakIcon>{sec.icon}</BreakIcon>
              <BreakLabel>{sec.label}</BreakLabel>
              <BreakTime>{sec.time}</BreakTime>
            </BreakRow>
          ) : (
            <Block key={sec.id} style={{ animationDelay: `${idx * 0.08}s` }}>
              <BlockHeader>
                <SectionBadge>{sec.badge !== undefined ? sec.badge : sec.id}</SectionBadge>
                <BlockTitleGroup>
                  <BlockIcon>{sec.icon}</BlockIcon>
                  <BlockTitle>{sec.label}</BlockTitle>
                </BlockTitleGroup>
                <TimeBadge>{sec.time}</TimeBadge>
              </BlockHeader>

              <ItemList>
                {sec.items.map((item, i) => (
                  <Item key={i}>
                    <Dot />
                    <ItemContent>
                      <ItemText>{item.text}</ItemText>
                      {item.detail && <ItemDetail>{item.detail}</ItemDetail>}
                      {item.speaker && (
                        <SpeakerChip>
                          <SpeakerName>{item.speaker}</SpeakerName>
                          <SpeakerDesig>{item.designation}</SpeakerDesig>
                        </SpeakerChip>
                      )}
                      {item.subItems && (
                        <SubItemGroup>
                          {item.subItems.map((s, j) => (
                            <SpeakerChip key={j}>
                              <SpeakerName>{s.speaker}</SpeakerName>
                              <SpeakerDesig>{s.designation}</SpeakerDesig>
                            </SpeakerChip>
                          ))}
                        </SubItemGroup>
                      )}
                    </ItemContent>
                  </Item>
                ))}
              </ItemList>
            </Block>
          )
        )}
      </Timeline>
    </Section>
  );
}

/* ─── Styles ────────────────────────────────────────────────── */

const Section = styled.section`
  background: #f5f7fa;
  padding: 12px 20px 20px;
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 10px 8px 10px;
  }
`;

const HeaderBlock = styled.div`
  text-align: center;
  margin-bottom: 52px;
`;

const SectionTitle = styled.h2`
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin-bottom: 14px;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #791e1b, #d6a54f);
  border-radius: 2px;
  margin: 0 auto 16px;
`;

const MetaRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  text-decoration: none;

  svg {
    color: #d6a54f;
    font-size: 17px;
    flex-shrink: 0;
  }

  &[href]:hover span {
    color: #791e1b;
    text-decoration: underline;
  }
`;

const Timeline = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/* ─── Main block ─── */

const Block = styled.div`
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.07);
  animation: ${fadeUp} 0.5s ease both;
  border-left: 5px solid #791e1b;
`;

const BlockHeader = styled.div`
  background: linear-gradient(135deg, #791e1b 0%, #a0302c 100%);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    padding: 14px 16px;
    gap: 10px;
  }
`;

const SectionBadge = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #d6a54f;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const BlockTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

const BlockIcon = styled.span`
  color: #d6a54f;
  font-size: 18px;
  flex-shrink: 0;
`;

const BlockTitle = styled.h3`
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const TimeBadge = styled.span`
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 20px;
  white-space: nowrap;
  margin-left: auto;

  @media (max-width: 600px) {
    font-size: 11px;
    padding: 3px 9px;
  }
`;

const ItemList = styled.ul`
  list-style: none;
  padding: 20px 24px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (max-width: 600px) {
    padding: 16px;
    gap: 12px;
  }
`;

const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d6a54f;
  flex-shrink: 0;
  margin-top: 6px;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ItemText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const ItemDetail = styled.span`
  font-size: 13px;
  color: #4b5563;
  font-style: italic;
`;

const SpeakerChip = styled.div`
  display: inline-flex;
  flex-direction: column;
  background: #fdf3e3;
  border-left: 3px solid #d6a54f;
  border-radius: 0 8px 8px 0;
  padding: 5px 12px;
  margin-top: 2px;
`;

const SpeakerName = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #791e1b;
`;

const SpeakerDesig = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

const SubItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
`;

/* ─── Break row ─── */

const BreakRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #d6a54f 0%, #e8b96a 100%);
  border-radius: 12px;
  padding: 16px 24px;
  animation: ${fadeUp} 0.5s ease both;

  @media (max-width: 600px) {
    padding: 14px 16px;
    gap: 10px;
  }
`;

const BreakIcon = styled.span`
  color: #fff;
  font-size: 20px;
  flex-shrink: 0;
`;

const BreakLabel = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex: 1;

  @media (max-width: 600px) {
    font-size: 13px;
  }
`;

const BreakTime = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #791e1b;
  background: rgba(255, 255, 255, 0.85);
  padding: 5px 14px;
  border-radius: 20px;
  white-space: nowrap;
`;
